var _path, _path2, _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroPath(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1584,
    height: 431,
    viewBox: "0 0 1584 431",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1529 56.6245L1472.04 99.2552C1402.84 151.05 1321.14 183.553 1235.27 193.447V193.447C1195.82 197.993 1155.85 193.177 1118.61 179.39L1068.19 160.724L1051.15 152.726C1024.93 140.43 1019.91 105.299 1041.63 86.1534V86.1534C1050.8 78.0721 1064.53 77.809 1074.08 85.4334V85.4334C1094.63 101.841 1096.1 132.81 1076.96 150.843L1057.48 169.191",
    stroke: "white",
    strokeWidth: 3,
    strokeDasharray: "18 18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.64 169.033V169.033C998.267 223.713 917.125 248.196 837.418 235.482L427.884 170.156C388.784 163.919 348.879 164.778 310.084 172.691L204.821 194.164C91.088 217.364 7.53879 314.693 1.83591 430.629V430.629",
    stroke: "#797878",
    strokeWidth: 3,
    strokeDasharray: "18 18"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1550.5,
    cy: 33.5,
    r: 31,
    stroke: "white",
    strokeWidth: 5,
    strokeDasharray: "16 16"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_851)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.007 165.521C352.817 169.089 356.226 171.983 359.813 172.164L378.02 173.124L387.411 196.895C388.506 198.995 389.483 201.224 393.506 201.425C395.557 201.53 399.822 201.744 400.154 195.429L399.14 174.238L414.209 175.031L419.034 184.101C419.741 185.453 420.629 185.993 421.759 185.996C422.37 185.96 425.756 186.643 425.9 183.908L424.834 169.265L427.401 154.809C427.506 152.828 425.983 152.449 423.537 152.259C421.943 152.179 421.674 152.748 420.68 154.103L414.837 162.403L399.828 161.655L403.033 140.693C403.366 134.38 399.098 134.165 397.049 134.058C393.024 133.856 391.82 135.972 390.511 137.951L378.644 160.601L360.456 159.694C356.871 159.512 353.194 161.954 353.007 165.521Z",
    fill: "#E46F44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.7708,
    height: 64.7708,
    fill: "white",
    transform: "translate(394.079 213.539) rotate(-132.047)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroPath);
export default __webpack_public_path__ + "static/media/hero-path.11e0d10296a0619d4fc4af1364df502a.svg";
export { ForwardRef as ReactComponent };